import "./Footer.css";

const LINKS_COL1 = [
  { label: "Inicio",     href: "/" },
  { label: "Clases",     href: "/clases" },
  { label: "Artículos",  href: "/articulos" },
  { label: "Recursos",   href: "/recursos" },
];

const LINKS_COL2 = [
  { label: "Facultad de Medicina San Fernando", href: "https://medicina.unmsm.edu.pe/" },
  { label: "Escuela de Tecnología Médica",      href: "https://medicina.unmsm.edu.pe/categoria/escuela-profesional-de-tecnologia-medica/" },
  { label: "UNMSM",                             href: "https://www.unmsm.edu.pe/" },
  { label: "Posgrado Medicina",                 href: "https://upgmedicina.unmsm.edu.pe/" },
];

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-accent" />

      <div className="footer-inner">

        {/* ── Columna 1: Marca + contacto ── */}
        <div className="footer-brand-col">
          <div className="footer-logo-row">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3a/UNMSM_coatofarms_seal.svg"
              alt="UNMSM"
              className="footer-unmsm-logo"
            />
            <div>
              <p className="footer-brand-name">STATISTIKDATA</p>
              <p className="footer-brand-sub">Estadística aplicada a Ciencias de la Salud</p>
            </div>
          </div>
          <p className="footer-desc">
            Plataforma educativa de la Escuela Profesional de Tecnología Médica,
            Facultad de Medicina San Fernando — UNMSM.
          </p>
          <div className="footer-contacts">
            <a href="mailto:cesar.lopez2@unmsm.edu.pe" className="footer-contact-chip">
              <svg className="footer-chip-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              cesar.lopez2@unmsm.edu.pe
            </a>

            {/* Enlace de WhatsApp - Formato internacional sin espacios ni símbolos */}
            <a href="https://wa.me/51920161304" target="_blank" rel="noreferrer" className="footer-contact-chip whatsapp">
              <svg className="footer-chip-svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 0 5.414 0 12.05c0 2.123.553 4.197 1.603 6.02L0 24l6.132-1.61c1.764.962 3.75 1.47 5.772 1.47h.005c6.635 0 12.049-5.415 12.049-12.051 0-3.213-1.252-6.234-3.525-8.508z"/>
              </svg>
              +51 920 161 304
            </a>
          </div>
        </div>

        {/* ── Columna 2: Links plataforma ── */}
        <div className="footer-nav-col">
          <p className="footer-nav-title">Plataforma</p>
          <ul className="footer-nav-list">
            {LINKS_COL1.map((l) => (
              <li key={l.label}><a href={l.href}>{l.label}</a></li>
            ))}
          </ul>
        </div>

        {/* ── Columna 3: Links institucionales ── */}
        <div className="footer-nav-col">
          <p className="footer-nav-title">Institucional</p>
          <ul className="footer-nav-list">
            {LINKS_COL2.map((l) => (
              <li key={l.label}>
                <a href={l.href} target="_blank" rel="noreferrer">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Columna 4: Logo Tecnología Médica ── */}
        <div className="footer-logo-col">
          <p className="footer-nav-title">Centro Federado</p>
          <div className="footer-tm-logo-wrap">
            <img
              src="https://pub-49a3e9f914ad427789951636484495f5.r2.dev/Images/405391297_789673119629918_3778085554237663617_n%20(2).jpg"
              alt="Centro Federado de Tecnología Médica UNMSM"
              className="footer-tm-logo"
            />
          </div>
          <div className="footer-univ-badges">
            <div className="footer-univ-badge">
              <div className="footer-univ-dot" />
              <span>Universidad Nacional Mayor de San Marcos</span>
            </div>
            <div className="footer-univ-badge">
              <div className="footer-univ-dot" />
              <span>Facultad de Medicina San Fernando</span>
            </div>
            <div className="footer-univ-badge">
              <div className="footer-univ-dot" />
              <span>E.P. Tecnología Médica — 1966</span>
            </div>
          </div>
        </div>

      </div>

      {/* ── Barra inferior ── */}
      <div className="footer-bottom">
        <span>StatistikData © 2025 — Todos los derechos reservados</span>
      </div>

    </footer>
  );
}